/**
 * How dictated words join whatever is already in the draft.
 *
 * Its own module because it is the one rule here that has a wrong answer people
 * would notice: glue a spoken sentence onto the end of a typed word and the
 * draft reads "the formwas filed". A person half-typing and then talking is the
 * ordinary case, not an edge one.
 *
 * Pure, so the rule is tested directly rather than through a microphone.
 */
export function joinDictated(existing: string, words: string): string {
  const clean = words.trim();
  if (!clean) return '';
  if (!existing.trim()) return clean;
  // One space after a word; nothing after the composer's own trailing space.
  return /\s$/.test(existing) ? clean : ` ${clean}`;
}
